export enum DBErrors {
  NotFoundElement = "Entity not found",
}
